<template>
    <div class="flex">
        <div class="day-name">
            <b-checkbox
                v-if="checkVariation && dia.lpss.length > 0"
                class="mr-auto" 
                :value="isAllLpsChecked"
                @input="checkAllLps"
            />
            
            <span
                :class="{'mr-auto': checkVariation, 'ml-auto': checkVariation && dia.lpss.length === 0}"
            >
                {{ $t(dia.nome) }}
                ({{
                    $moment()
                    .day(dia.id)
                    .format('L')
                }})
            </span>
        </div>
        <div 
            class="schedule"
            :class="{'bottom-smooth-border': checkVariation}"
        >
            <div class="vazio" v-if="dia.lpss.length == 0">
                {{ $t('sem-registro') }}
            </div>
            <div class="day-lps" v-for="(lps, i) in dia.lpss" :key="i">
                <b-checkbox
                    v-if="checkVariation"
                    class="mr-auto"
                    :value="isLpsChecked(lps.id)"
                    @input="(checkValue) => checkLps(checkValue, lps)"
                />
                <span v-text="lps.nome"/>
                <span
                    v-if="lps.situacao == 0 || lps.replicapda != 3"
                    v-tippy 
                    :title="$t('lps') + ' ' + $t('inativa')"
                >
                    <svg
                        style="fill: rgba(255, 0, 0, 0.6); cursor: default"
                        class="svg-icons"
                    >
                        <use
                            :xlink:href="
                                require('@/assets/img/icons/alert-circle.svg') +
                                '#layer'
                            "
                        ></use>
                    </svg>
                </span>
                <svg
                    v-if="!checkVariation"
                    class="svg-icons"
                    @click="() => onLpsRemove(dia, i)"
                >
                    <use
                        :xlink:href="require('@/assets/img/icons/close.svg') + '#layer'"
                    ></use>
                </svg>
                <svg
                    v-if="!checkVariation"
                    class="svg-icons"
                    @click="() => onLpsDetail(lps, i, dia.id)"
                >
                    <use
                        :xlink:href="
                            require('@/assets/img/icons/eye-outline.svg') + '#layer'
                        "
                    ></use>
                </svg>
                <div
                    class="day-lps-contratos"
                    v-if="lps.contratos && lps.contratos.length > 0"
                >
                    <ul>
                        <li v-for="(c, j) in lps.contratos" :key="j + '_' + i">
                            <div class="is-flex is-flex-column">
                                <span class="color-primary is-bold">
                                    {{ c.proContratoLps.contrato.proCliente.nome }}
                                </span>
                                <span>
                                    {{ c.proContratoLps.contrato.descricao }}
                                </span>
                            </div>
                            <span
                                v-if="
                                    c.proContratoLps.replicapda != 3 ||
                                    c.proContratoLps.situacao != 1
                                "
                                v-tippy 
                                :title="
                                    $t('contrato') +
                                    ' ' +
                                    $t('lps') +
                                    ' ' +
                                    $t('inativo')
                                "
                            >
                                <svg
                                    style="fill: rgba(255, 0, 0, 0.6); cursor: default"
                                    class="svg-icons"
                                >
                                    <use
                                        :xlink:href="
                                            require('@/assets/img/icons/alert-circle.svg') +
                                            '#layer'
                                        "
                                    ></use>
                                </svg>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="!checkVariation" class="day-footer">
            <div class="day-footer-item" @click="() => onAdd(dia.id)">
                <span
                    v-tippy 
                    :title="$t('adicionar-lps')"
                >
                    <svg class="svg-icons">
                        <use
                            :xlink:href="
                                require('@/assets/img/icons/plus-box.svg') + '#layer'
                            "
                        ></use>
                    </svg>
                </span>
            </div>

            <div class="day-footer-item" @click="() => onRemove(dia.id)">
                <span
                    v-tippy 
                    :title="$t('excluir-dia')"
                >
                    <svg class="svg-icons day-footer-item">
                        <use
                            :xlink:href="
                                require('@/assets/img/icons/delete.svg') + '#layer'
                            "
                        ></use>
                    </svg>
                </span>
            </div>
            <div class="day-footer-item" @click="() => onTransfer(dia.id)">
                <span
                    v-tippy 
                    :title="$t('Copiar/transferir itinerário')"
                >
                    <svg class="svg-icons day-footer-item">
                        <use
                            :xlink:href="
                                require('@/assets/img/icons/content-duplicate.svg') +
                                '#layer'
                            "
                        ></use>
                    </svg>
                </span>
            </div>
            <div class="day-footer-item" @click="() => onDuplicate(dia.id)">
                <span
                    v-tippy 
                    :title="$t('duplicar-dia')"
                >
                    <svg class="svg-icons day-footer-item">
                        <use
                            :xlink:href="
                                require('@/assets/img/icons/content-copy.svg') +
                                '#layer'
                            "
                        ></use>
                    </svg>
                </span>
            </div>
            <div class="day-footer-item" @click="() => onLocation(dia.id)">
                <span
                    v-tippy 
                    :title="$t('mapa')"
                >
                    <svg class="svg-icons day-footer-item">
                        <use
                            :xlink:href="
                                require('@/assets/img/icons/map-marker.svg') + '#layer'
                            "
                        ></use>
                    </svg>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dia: {
            type: Object,
        },
        checkVariation: {
            type: Boolean,
            default: false
        },
        onLpsRemove: {
            type: Function
        },
        onLpsDetail: {
            type: Function
        },
        onAdd: {
            type: Function
        },
        onRemove: {
            type: Function
        },
        onTransfer: {
            type: Function
        },
        onDuplicate: {
            type: Function
        },
        onLocation: {
            type: Function
        },
        lpssSelected: {
            type: Array
        },
        setLpssSelected: {
            type: Function
        }
    },
    computed: {
        isAllLpsChecked() {
            return this.lpssSelected.length === this.dia.lpss.length;
        }
    },
    methods: {
        isLpsChecked(lpsId) {
            return this.lpssSelected.some(({id}) => id === lpsId);
        },
        checkAllLps(isAllChecked) {
            if(isAllChecked) {
                this.setLpssSelected([...this.dia.lpss])

                return;
            }

            this.setLpssSelected([]);
        },
        checkLps(isChecked, lpsChecked) {
            if(isChecked) {
                this.setLpssSelected([
                    lpsChecked,
                    ...this.lpssSelected
                ])

                return;
            }

            this.setLpssSelected(this.lpssSelected.filter(lpssSelected => lpssSelected.id != lpsChecked.id));
        }
    }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}

.day-name {
    border: 1px solid $table-border;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    padding: 10px;
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.day-footer {
    border: 1px solid $table-border;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    padding: 10px;
    border-radius: 0 0 10px 10px;
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    > .day-footer-item {
        position: relative;
        cursor: pointer;
    }
}

.bottom-smooth-border {
    border-radius: 0 0 10px 10px;
    border-bottom: 1px solid $table-border;
}

.schedule {
    background: $darker-bg-color;
    border-left: 1px solid $table-border;
    border-right: 1px solid $table-border;
    flex: 1 1 auto;
    min-height: 200px;
    max-height: 500px;
    overflow: auto;
    

    .vazio {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: $text-color;
        font-size: 14px;
    }

    .day-lps {
        background: $sovis-white;
        margin: 5px;
        border: 1px solid $table-border;
        padding: 5px;
        border-radius: 6px;
        > span {
            font-weight: 600;
            line-height: normal;
            font-size: 12px;
            color: $sovis-black;
            word-wrap: break-word;
            width: 50%;
            display: inline-block;
            vertical-align: text-top;
        }
        > svg {
            float: right;
            cursor: pointer;
        }
        > .day-lps-contratos {
            border-top: 1px solid $table-border;
            ul {
                margin-bottom: 0;
                li {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    word-break: break-all;
                    font-style: normal;
                    font-weight: 300;
                    line-height: normal;
                    font-size: 11px;
                    color: $darker-gray-color;
                    margin: 8px 0;
                }
            }
        }
        &:hover {
            border: 1px solid $light-gray-color;
        }
    }
}
</style>